<template>
    <div class="kt-portlet">
        <div class="kt-portlet__body" style="color: black; background-color: #fff">
            <h6>{{ $t('dashboard.label.settlement_amount') }}</h6>
            <div class="text-center">
                <h2 class="fix-margin">
                    {{ settlement.amount }}
                    <span style="font-size: 1.5rem">
                        {{' ' + $t('currency.rial')}}
                    </span>
                </h2>
            </div>
            <div class="line-divider mt-4 mb-3"></div>
            <div class="row">
                <div class="col-md-12 col-lg-12 col-sm-12">
                    <div class="mb-3" style="font-size: 0.82rem">{{ $t('dashboard.label.settlement_count') }}</div>
                    <div class="text-center">
                        <h4 class="fix-margin">
                            {{ settlement.count }}
                        </h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "settlements",

        props: {
            settlement: {
                default() {
                    return {}
                }
            },
        },
    }
</script>

<style scoped>

</style>